import {reactive, ref} from "vue";
import axios from "axios";
import {io} from "socket.io-client";
import EventBus from "@/AppEventBus";
import roles from "@/router/roles";
import i18n from "@/i18n";
import router from "@/router";

export default reactive({
  auth: {
    init: false,
    isAuth: false,
  },
  token: "",
  plan: undefined,
  user: undefined,
  role: undefined,
  isApp: false,
  standAlone: false,
  ideMode: false,
  get isLimitedMode() {
    return Boolean(this.standAlone || this.ideMode);
  },
  adminRoute: {
    Home: ["/app/dashboard", "/app/tasks"],
    Explorer: ["/app/fileExplorer", "/app/shortcut"],
    Users: ["/app/users", "/app/roles", "/app/session"],
    System: ["/app/store", "/app/profile", "/app/setting", "/app/license"],
    About: ["/app/contact", "/app/landing", "/app/website"],
  },
  applyLimitedMode() {
    if (this.isLimitedMode) {
      delete this.adminRoute.Users;
      if (this.adminRoute.System) {
        this.adminRoute.System = this.adminRoute.System.filter(
          r => r !== "/app/store" && r !== "/app/license"
        );
      }
    }
  },
  filterDisabledRoutes(routeObj) {
    if (!this.isLimitedMode || !routeObj) return routeObj;
    const disabled = ["/app/store", "/app/license", "/app/users", "/app/roles", "/app/session"];
    const filtered = {};
    for (const [key, items] of Object.entries(routeObj)) {
      if (key === "Users") continue;
      if (Array.isArray(items)) {
        const allowed = items.filter(r => !disabled.some(d => r === d || r.startsWith(d + "/")));
        if (allowed.length > 0) {
          filtered[key] = allowed;
        }
      } else {
        filtered[key] = items;
      }
    }
    return filtered;
  },
  socket: undefined,
  logo: {
    src: "/images/logo.svg",
    name: "Motanamy Core",
  },
  setting: {
    scale: 14,
    style: "lara-light-indigo",
    dark: false,
    layoutMode: "static",
    lang: "en",
  },
  loading: ref(false),
  loadSetting() {
    this.setting = {
      ...this.setting,
      ...JSON.parse(localStorage.getItem("MotanamyEASetting")),
    };
    this.applyTheme(this.setting);
    this.token = localStorage.getItem("MotanamyEA") || "";
  },
  async validToken() {
    try {
      if (this.token == "") throw new Error();
      const {data} = await axios.get(`auth/validToken`);
      this.signIn(data);
      return true;
    } catch (err) {
      return false;
    }
  },
  applyTheme(theme) {
    document.documentElement.style.fontSize = theme.scale + "px";
    EventBus.emit("theme-change", {theme: theme.style, dark: theme.dark});
    i18n.global.locale = theme.lang || "en";
  },
  roleF(key, name) {
    if (this.user.roleId == "admin") return true;
    else
      return this.role.apps[key]
        ? this.role.apps[key].roles[name].value
        : false;
  },
  logout() {
    this.auth.isAuth = false;
    router.push("/signin").then(res => {
      this.socket.disconnect();
      localStorage.removeItem("MotanamyEA");
      this.user = undefined;
      this.role = undefined;
      this.plan = undefined;
      this.token = undefined;
      this.standAlone = false;
      this.ideMode = false;
    });
  },
  signIn(data) {
    this.user = data.user;
    this.role = data.role;
    this.token = data.token;
    this.auth.isAuth = true;
    this.plan = data.plan;
    this.standAlone = Boolean(data.standAlone);
    this.ideMode = Boolean(data.ideMode);
    if (data.token) localStorage.setItem("MotanamyEA", data.token);
    if (data.user.roleId == "admin") {
      this.applyLimitedMode();
      this.role.route = this.adminRoute;
      this.role.apps = roles;
    } else if (this.role && this.role.route) {
      this.role.route = this.filterDisabledRoutes(this.role.route);
    }
    this.socket = io(
      `${
        process.env.NODE_ENV == "development" ? "http://127.0.0.1:3200" : ""
      }/main`,
      {
        extraHeaders: {
          Authorization: `Bearer ${this.token}`,
        },
        query: {
          ...data.user,
        },
      }
    );
    this.socket.on("connect", () => {
      console.log("[socket] connect");
      this.socket.on("[session] closeSession", () => {
        this.logout();
      });
      this.socket.on("[core-users]", data => {
        if (data.o == "update" && data.id == this.user.id) {
          this.logout();
        }
      });
      this.socket.on("[core-roles]", data => {
        if (data.o == "update" && data.id == this.role.id) {
          location.reload();
        }
      });
    });
    this.socket.on("disconnect", reason => {
      console.log("[socket] disconnect");
    });
  },
});
